import React, { useState, useEffect } from "react";
import zipcodes from "zipcodes";
import { HeadingLarge, Heading } from "~/components/.base/headings";
import { SearchForm, InputSelect } from "~/components/.base/inputs";
import { Grid, Row, Col } from "~/components/.base/containers";
import { abbrToStateMap } from "../helper-objects.js";
import SearchIcon from "~/images/icons/search.svg";
import ArrowDown from "~/images/icons/arrow_normal_down.svg";
import "./SearchHeader.scss";

const SearchHeader = ({ searchQuery, stateQuery, distance, setDistance }) => {
    const [zipCode, setZipCode] = useState("");
    const [zipWarning, setZipWarning] = useState("");
    const [activeState, setActiveState] = useState("");
    useEffect(() => {
        if (searchQuery) {
            setZipCode(searchQuery);
            const stateInfo = zipcodes.lookup(searchQuery);
            if (stateInfo) {
                setActiveState(abbrToStateMap[stateInfo.state]);
            }
        }
        if (stateQuery) {
            setActiveState(abbrToStateMap[stateQuery]);
        }
    }, [searchQuery, stateQuery]);
    const handleSearch = (e) => {
        e.preventDefault();
        if (zipCode.length === 5) {
            window.location.href = `/locations/search?q=${zipCode}&dist=${distance}`;
        } else {
            setZipWarning("Please enter a valid ZIP code");
        }
    };
    return (
        <Grid className="search-header">
            <Row align="flex-end">
                <Col size={1} pd="1rem 2.5rem">
                    <Row className="search-form">
                        <Col size={1}>
                            <form onSubmit={handleSearch}>
                                <SearchForm
                                    width="calc(100% - 1rem)"
                                    md="0 1rem .75rem 0"
                                >
                                    <label htmlFor="zipSearch">Zip Code</label>
                                    <input
                                        placeholder="Search by ZIP"
                                        name="zipSearch"
                                        type="number"
                                        min="0"
                                        max="99999"
                                        value={zipCode}
                                        onChange={(e) =>
                                            setZipCode(e.target.value)
                                        }
                                    />
                                    <button type="submit">
                                        <SearchIcon />
                                    </button>
                                    {zipWarning.length ? (
                                        <div class="error">{zipWarning}</div>
                                    ) : null}
                                </SearchForm>
                            </form>
                        </Col>
                        <Col size={1}>
                            <InputSelect width="100%">
                                <label htmlFor="range">Range</label>
                                <select
                                    name="range"
                                    value={distance}
                                    onBlur={(e) => setDistance(e.target.value)}
                                    onChange={(e) =>
                                        setDistance(e.target.value)
                                    }
                                >
                                    <option value="5">5 miles</option>
                                    <option value="15">15 miles</option>
                                    <option value="50">50 miles</option>
                                    <option value="100">100 miles</option>
                                </select>
                                <ArrowDown />
                            </InputSelect>
                        </Col>
                    </Row>
                </Col>
                <Col className=" heading sub-heading" size={1} pd="2rem 4rem">
                    <HeadingLarge md="0px">
                        <span className="red">{activeState}</span>
                    </HeadingLarge>
                    {stateQuery ? (
                        <Heading>
                            All events in{" "}
                            <span className="red">
                                {abbrToStateMap[stateQuery]}
                            </span>{" "}
                            this week
                        </Heading>
                    ) : null}
                    {searchQuery ? (
                        <Heading>
                            All events near{" "}
                            <span className="red">{searchQuery}</span> this week
                        </Heading>
                    ) : null}
                </Col>
                <Col size={1} pd="2rem 4rem"></Col>
            </Row>
        </Grid>
    );
};
export default SearchHeader;
